export default __webpack_public_path__ + "static/media/kibawe_mdrrmo_logo2.60430706.png";